module.exports = __webpack_public_path__ + "static/media/login.3f237a14.svg";